<template>
	<div>
		<v-stage ref="stage"
				 :config="configKonva">

			<v-layer ref="layer" >
				<!--<v-line ref="figure" :config="{-->
							<!--x: 0,-->
							<!--y: 0,-->
							<!--points: this.pointsStart,-->
							<!--tension: 0.4,-->
							<!--closed: true,-->
							<!--fill: '#dddddd',-->
						  <!--}"-->
				<!--&gt;</v-line>-->
				<v-line ref="figure2" :config="{
							x: 0,
							y: 0,
							points: this.pointsStart,
							tension: 0.4,
							closed: true,
							fill: '#ffffff',
						  }"
				></v-line>
			</v-layer>
			<v-layer ref="dragLayer"></v-layer>
		</v-stage>
	</div>
</template>

<script>
    import Vue from 'vue';
    import Bus from '../bus';
    import VueKonva from 'vue-konva';

    Vue.use(VueKonva);

    const width = window.innerWidth;
    let height = 650;
    if(window.innerWidth > 1400) {
        height = 800;
    }
    if(window.innerWidth > 1600) {
        height = 1000;
    }

    const widthX = Math.round(width)
    const heightY = Math.round(height)
    let vm = {};
    export default {
        name: "canvasy-main",
        data() {
            return {
                list: [],
                configKonva: {
                    width: width,
                    height: height
                },
                src: '/static/video/guitar.mp4',
                pointsStart: [width,0, width,0,  width,0, width,0, width,0, width,0, width,0, width,0, width,0,  /*widthX,heightY/100*75,*/ widthX,heightY, 0,heightY, 0,0],
                pointsEndLayer:[widthX/100*8,heightY/100*-10, widthX/100*1,heightY/100*18,  widthX/100*4,heightY/100*43, widthX/100*15,heightY/100*60, widthX/100*30,heightY/100*65, widthX/100*54,heightY/100*64, widthX/100*65,heightY/100*68, widthX/100*88,heightY/100*88, widthX/100*105,heightY/100*88, widthX,heightY, 0,heightY, 0,0],
                pointsTransform: [],
                pointsTransform2: [],
                pointsEndLayer2:[widthX/100*0,heightY/100*-10, widthX/100*0,heightY/100*19,  widthX/100*2,heightY/100*47, widthX/100*18,heightY/100*66, widthX/100*35,heightY/100*69, widthX/100*56,heightY/100*68, widthX/100*64,heightY/100*72, widthX/100*87,heightY/100*92, widthX/100*102,heightY/100*92, widthX,heightY, 0,heightY, 0,0],
            };
        },
        methods: {
            randomInteger(min, max) {
                var rand = min + Math.random() * (max + 1 - min);
                rand = Math.floor(rand);
                return rand;
            },
            transform(){

                // this.pointsTransform = this.pointsEndLayer.map(elem => {
                //     return this.randomInteger(elem * 0.98, elem * 1.2)
                // });

                /*let tween = new Konva.Tween({
                    easing: Konva.Easings.EaseIn,
                    node: this.$refs.figure.getStage(),
                    duration: 1,
                    points: this.pointsEndLayer,
                    tension: 0.4,
                    closed: true,
                    fill: '#f5f3f3',

                });
                setTimeout(function() {
                    tween.play();
                }, 250);*/

                /*this.pointsTransform2 = this.pointsEndLayer2.map(elem => {
                    return this.randomInteger(elem * 0.98, elem * 1.2)
                });*/

                let tween2 = new Konva.Tween({
                    easing: Konva.Easings.EaseIn,
                    node: this.$refs.figure2.getStage(),
                    duration: 1,
                    points: this.pointsEndLayer,
                    tension: 0.4,
                    closed: true,
                    fill: '#ffffff',
                });
                setTimeout(function() {
                    tween2.play();
                }, 200);
            },
            handleResize(){
                this.configKonva.width = window.innerWidth;
            }
        },
        mounted() {
            Bus.$on('canvas-transform', ()=>{
                this.transform();
            });

        },
        created() {
            window.addEventListener('resize', this.handleResize);
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/canvasy-main.vue